import { Util } from "../utils";
import { makeApiCall } from "./xhr";
import { InventoryMock } from "./mocks";

const USE_MOCK = process.env.REACT_APP_MOCK === "true";
const BASE_URL = `${process.env.REACT_APP_API_URL}/Inventories`;
const BASE_URL_TWO = `${process.env.REACT_APP_API_URL}/Inventories`;

export const getCurrencies = async () => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve(InventoryMock.GET_CURRENCIES);
      }, 1000)
    );
  }

  return makeApiCall(`${BASE_URL}/GetCurrencies`, "get");
};

export const getInventories = async (params) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve(InventoryMock.GET_INVENTORIES);
      }, 1000)
    );
  }

  return makeApiCall(
    `${BASE_URL_TWO}/GetInventories?${Util.objectToQueryString(params)}`,
    "get"
  );
};

export const getInventory = async (params) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve(InventoryMock.GET_INVENTORY);
      }, 1000)
    );
  }

  return makeApiCall(
    `${BASE_URL_TWO}/GetInventory?${Util.objectToQueryString(params)}`,
    "get"
  );
};

export const createInventory = async (payload) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve();
      }, 1000)
    );
  }

  return makeApiCall(`${BASE_URL_TWO}/CreateInventory`, "post", payload);
};

export const deleteInventory = async (payload) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve();
      }, 1000)
    );
  }

  return makeApiCall(`${BASE_URL_TWO}/DeleteInventory`, "post", payload);
};

export const getInventoryApprovalSettings = async () => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve(InventoryMock.GET_APPROVAL_SETTINGS);
      }, 1000)
    );
  }

  return makeApiCall(`${BASE_URL_TWO}/GetInventoryApprovalSettings`, "get");
};

export const updateInventoryApprovalSetting = async (payload) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve();
      }, 1000)
    );
  }

  return makeApiCall(
    `${BASE_URL_TWO}/UpdateInventoryApprovalSetting`,
    "post",
    payload
  );
};

export const deleteInventoryApprovalSetting = async (payload) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve();
      }, 1000)
    );
  }

  return makeApiCall(
    `${BASE_URL_TWO}/DeleteInventoryApprovalSetting`,
    "post",
    payload
  );
};

export const requestProduct = async (payload) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve();
      }, 1000)
    );
  }

  return makeApiCall(`${BASE_URL_TWO}/RequestProduct`, "post", payload);
};

export const requestProducts = async (payload) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve();
      }, 1000)
    );
  }

  return makeApiCall(`${BASE_URL_TWO}/RequestProducts`, "post", payload);
};

export const restockInventory = async (payload) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve();
      }, 1000)
    );
  }

  return makeApiCall(`${BASE_URL_TWO}/RestockInventory`, "post", payload);
};

export const inventoryQuantityEdit = async (payload) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve();
      }, 1000)
    );
  }

  return makeApiCall(`${BASE_URL_TWO}/InventoryQuantityEdit`, "post", payload);
};

export const getMyPendingRequestsForApproval = async (params) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve(InventoryMock.GET_MY_PENDING_REQUESTS);
      }, 1000)
    );
  }

  return makeApiCall(
    `${BASE_URL_TWO}/GetMyPendingRequestsForApproval?${Util.objectToQueryString(
      params
    )}`,
    "get"
  );
};

export const getMyInventoryRequests = async (params) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve(InventoryMock.GET_MY_REQUESTS);
      }, 1000)
    );
  }

  return makeApiCall(
    `${BASE_URL_TWO}/GetMyInventoryRequests?${Util.objectToQueryString(
      params
    )}`,
    "get"
  );
};

export const getInventoryRequests = async (params) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve(InventoryMock.GET_ALL_REQUESTS);
      }, 1000)
    );
  }

  return makeApiCall(
    `${BASE_URL_TWO}/GetInventoryRequests?${Util.objectToQueryString(params)}`,
    "get"
  );
};

export const getInventoryQuantityRestockApprovalSettings = async (payload) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve();
      }, 1000)
    );
  }

  return makeApiCall(
    `${BASE_URL_TWO}/GetInventoryQuantityRestockApprovalSettings`,
    "get",
    payload
  );
};

export const updateInventoryQuanitityRestockApprovalSetting = async (
  payload
) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve();
      }, 1000)
    );
  }

  return makeApiCall(
    `${BASE_URL_TWO}/UpdateInventoryQuanitityRestockApprovalSetting`,
    "post",
    payload
  );
};

export const deleteInventoryQuantityRestockApprovalSetting = async (
  payload
) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve();
      }, 1000)
    );
  }

  return makeApiCall(
    `${BASE_URL_TWO}/DeleteInventoryQuantityRestockApprovalSetting`,
    "post",
    payload
  );
};

export const getMyPendingInventoryRestockApproval = async (params) => {
  return makeApiCall(
    `${BASE_URL_TWO}/GetMyPendingInventoryRestockApproval?${Util.objectToQueryString(
      params
    )}`,
    "get"
  );
};

export const getMyPendingInventoryQuantityEditApproval = async (params) => {
  return makeApiCall(
    `${BASE_URL_TWO}/GetMyPendingInventoryQuantityEditApproval?${Util.objectToQueryString(
      params
    )}`,
    "get"
  );
};

export const approveInventoryQuantityRestock = async (payload) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve();
      }, 1000)
    );
  }

  return makeApiCall(
    `${BASE_URL_TWO}/ApproveInventoryQuantityRestock`,
    "post",
    payload
  );
};

export const approveInventoryQuantityEdit = async (payload) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve();
      }, 1000)
    );
  }

  return makeApiCall(
    `${BASE_URL_TWO}/ApproveInventoryQuantityEdit`,
    "post",
    payload
  );
};

//added on march 15 2023
export const getStaffName = (id) => {
  const body = JSON.stringify({ ids: [id] });
  return makeApiCall(
    `https://services.hh-converge.com/resources/api/staffs/id`,
    "put",
    body,
    { "X-API-KEY": "fq05322d-429b-4f77-8a4p-a97ry62eb37k" }
  );
};

export const getInventoryHistorys = async (params) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve(InventoryMock.GET_INVENTORY_HISTORIES);
      }, 1000)
    );
  }

  return makeApiCall(
    `${BASE_URL_TWO}/GetInventoryHistorys?${Util.objectToQueryString(params)}`,
    "get"
  );
};

export const updateRequestedProduct = async (payload) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve();
      }, 1000)
    );
  }

  return makeApiCall(`${BASE_URL_TWO}/UpdateRequestedProduct`, "post", payload);
};

export const updateRequestProductStatus = async (payload) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve();
      }, 1000)
    );
  }

  return makeApiCall(
    `${BASE_URL_TWO}/UpdateRequestProductStatus`,
    "post",
    payload
  );
};

export const bulkUpdateRequestProductStatus = async (payload) => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve();
      }, 1000)
    );
  }

  return makeApiCall(
    `${BASE_URL_TWO}/BulkUpdateRequestProductStatus`,
    "post",
    payload
  );
};

export const getInventorySummary = async () => {
  if (USE_MOCK) {
    return new Promise((resolve) =>
      setTimeout(() => {
        resolve(InventoryMock.GET_INVENTORY_SUMMARY);
      }, 1000)
    );
  }

  return makeApiCall(`${BASE_URL_TWO}/GetInventorySummary`, "get");
};
